import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const emailFormatValidator: ValidatorFn = (control: AbstractControl):
  ValidationErrors | null => {
  let invalid: boolean = false;

  if (!control.value) {
    return null;
  }

  if (control.value !== "" && !control.value.toString().trim().match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)) {
    invalid = true;
  }

  return invalid ? { invalidEmail: true } : null;
}

export const emailListFormatValidator: ValidatorFn = (control: AbstractControl):
  ValidationErrors | null => {
  let invalid: boolean = false;
  let value = control.value;

  if (!value) {
    return null;
  }

  var emails = value.split(";");

  if (emails.length > 0) {
    for (var i = 0; i < emails.length; i++) {
      if (emails[i] !== "" && !emails[i].toString().trim().match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)) {
        invalid = true;
      }
    }
  }

  return invalid ? { invalidEmail: true } : null;
}

